import React, { useEffect } from "react";
import "./Expertise.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaLaptopMedical, FaAmbulance, FaHandHoldingMedical } from "react-icons/fa";

const Expertise = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });

    // SEO Meta
    document.title = "Expertise | Dr. Chavan Multispeciality Hospital, Indapur";

    const metaDescription = document.createElement("meta");
    metaDescription.name = "description";
    metaDescription.content =
      "Discover why Dr. Chavan Multispeciality Hospital in Indapur is trusted for advanced laparoscopy, gynecology, 24/7 emergency services, and patient-centered care.";
    document.head.appendChild(metaDescription);

    const metaKeywords = document.createElement("meta");
    metaKeywords.name = "keywords";
    metaKeywords.content =
      "Advanced Laparoscopy Indapur, Gynecology Indapur, Emergency Services, Patient-Centered Care, Dr. Chavan Hospital";
    document.head.appendChild(metaKeywords);

    const canonical = document.createElement("link");
    canonical.rel = "canonical";
    canonical.href = "https://drchavanhospital.in/expertise";
    document.head.appendChild(canonical);

    // JSON-LD Structured Data
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "MedicalOrganization",
      "name": "Dr. Chavan Multispeciality Hospital",
      "url": "https://drchavanhospital.in/",
      "logo": "https://drchavanhospital.in/images/logo.webp",
      "description": "Advanced laparoscopy, gynecology, 24/7 emergency care, and patient-focused medical expertise in Indapur.",
      "medicalSpecialty": [
        "Minimally Invasive Surgery",
        "Gynecology",
        "Emergency Medicine",
        "Patient Care"
      ],
      "sameAs": [
        "https://www.facebook.com/yourhospital",
        "https://www.instagram.com/yourhospital",
        "https://www.linkedin.com/company/yourhospital"
      ]
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(metaDescription);
      document.head.removeChild(metaKeywords);
      document.head.removeChild(canonical);
      document.head.removeChild(script);
    };
  }, []);

  const items = [
    {
      icon: <FaLaptopMedical />,
      title: "Advanced Laparoscopy & Gynaecology",
      desc: "Offering minimally invasive laparoscopic surgeries and comprehensive gynecological care with precision, safety, and faster recovery.",
    },
    {
      icon: <FaAmbulance />,
      title: "24/7 Emergency Services",
      desc: "Always ready for emergencies with quick response and life-saving care.",
      highlight: true,
    },
    {
      icon: <FaHandHoldingMedical />,
      title: "Patient-Centered Approach",
      desc: "Comfort and well-being come first, with personalized care and a supportive environment.",
    },
  ];

  return (
    <section className="expertise-section">
      <p className="top-subtitle" data-aos="fade-up">WHY CHOOSE US?</p>
      <h2 className="main-title" data-aos="fade-up">
        Where Expertise Meets Compassion
      </h2>
      <p className="subtitle" data-aos="fade-up">
        Your Trusted Healthcare Partner!
      </p>

      <div className="icons-divider" data-aos="zoom-in">
        ❇ ❇ ❇ ❇ ❇
      </div>

      <div className="expertise-grid">
        {items.map((box, i) => (
          <div
            className={`expertise-card ${box.highlight ? "highlight" : ""}`}
            data-aos={i % 2 === 0 ? "fade-up" : "fade-down"}
            data-aos-delay={i * 200}
            key={i}
          >
            <div className="icon">{box.icon}</div>
            <h3>{box.title}</h3>
            <p>{box.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Expertise;
